import React, { type ComponentType, Suspense, type SVGAttributes } from 'react';
import { lazily } from 'react-lazily';

const dynamic = (
  loader: () => Promise<{
    ReactComponent: ComponentType<SVGAttributes<SVGSVGElement>>;
  }>
) => {
  const { ReactComponent } = lazily(loader);
  return ReactComponent;
};

const ICONS = {
  info: dynamic(() => import('./assets/info.svg')),
  bag: dynamic(() => import('./assets/bag.svg')),
  'tabby-care': dynamic(() => import('./assets/tabby-care.svg')),
  shariat: dynamic(() => import('./assets/shariat.svg')),
  'shariat-modern': dynamic(() => import('./assets/shariat-modern.svg')),
  percentages: dynamic(() => import('./assets/percentages.svg')),
  people: dynamic(() => import('./assets/people.svg')),
  ramadan: dynamic(() => import('./assets/ramadan.svg')),
  card: dynamic(() => import('./assets/card.svg')),
  moon: dynamic(() => import('./assets/moon.svg')),
  protection: dynamic(() => import('./assets/protection.svg')),
  lightning: dynamic(() => import('./assets/lightning.svg')),
  asterisks: dynamic(() => import('./assets/asterisks.svg')),
  deal: dynamic(() => import('./assets/deal.svg')),
  arrow: dynamic(() => import('./assets/arrow.svg')),
  star: dynamic(() => import('./assets/star.svg')),
};

type IconNames = keyof typeof ICONS;

export interface IconProps {
  name: IconNames;
  svgAttributes?: SVGAttributes<SVGSVGElement>;
}

export const Icon = ({ name, svgAttributes }: IconProps) => {
  const IconComponent = ICONS[name];

  return (
    <Suspense fallback={null}>
      <IconComponent {...svgAttributes} />
    </Suspense>
  );
};
